import { render } from "./Modal.vue?vue&type=template&id=d8e2627a&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=d8e2627a&lang=css&scoped=true"

import exportComponent from "C:\\PROJEKTE\\SLP_DE\\APP\\sjp_de\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8e2627a"]])

export default __exports__